var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarnRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 9.60002C17.4999 8.7716 16.8283 8.10002 15.9999 8.10002C15.1715 8.10002 14.4999 8.7716 14.4999 9.60002L17.4999 9.60002ZM14.4999 16.8C14.4999 17.6285 15.1715 18.3 15.9999 18.3C16.8283 18.3 17.4999 17.6285 17.4999 16.8L14.4999 16.8ZM14.4999 22.4C14.4999 23.2285 15.1715 23.9 15.9999 23.9C16.8283 23.9 17.4999 23.2285 17.4999 22.4L14.4999 22.4ZM17.4999 22C17.4999 21.1716 16.8283 20.5 15.9999 20.5C15.1715 20.5 14.4999 21.1716 14.4999 22L17.4999 22ZM14.4999 9.60002L14.4999 16.8L17.4999 16.8L17.4999 9.60002L14.4999 9.60002ZM3.0999 16C3.0999 8.87555 8.87543 3.10002 15.9999 3.10002L15.9999 0.100024C7.21858 0.100023 0.0999051 7.2187 0.0999044 16L3.0999 16ZM15.9999 3.10002C23.1244 3.10002 28.8999 8.87555 28.8999 16L31.8999 16C31.8999 7.2187 24.7812 0.100025 15.9999 0.100024L15.9999 3.10002ZM28.8999 16C28.8999 23.1245 23.1244 28.9 15.9999 28.9L15.9999 31.9C24.7812 31.9 31.8999 24.7814 31.8999 16L28.8999 16ZM15.9999 28.9C8.87543 28.9 3.0999 23.1245 3.0999 16L0.0999044 16C0.0999036 24.7813 7.21858 31.9 15.9999 31.9L15.9999 28.9ZM17.4999 22.4L17.4999 22L14.4999 22L14.4999 22.4L17.4999 22.4Z",
    fill: "#FFC736"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnRound);
export default __webpack_public_path__ + "static/media/warn_round.f60c3356.svg";
export { ForwardRef as ReactComponent };